import Splide from "@splidejs/splide";

/**
 * @file
 * CDA JavaScript.
 */
(function (Drupal, drupalSettings) {
  Drupal.behaviors.mainMenu = {
    attach: function (context, settings) {
      // Main menu activation
      const $menu = document.querySelector("#block-cda2023-main-menu");
      const $children = document.querySelector(
        "#block-cda2023-mainnavigation-2"
      );

      once("main-menu-toggle", ".region-primary-menu", context).forEach(
        (el) => {
          const handleOpen = () => {
            $menu.classList.add("is-open");
            $children.classList.add("is-open");
          };

          const handleClose = () => {
            $menu.classList.remove("is-open");
            $children.classList.remove("is-open");
          };

          // Mouse events
          el.addEventListener("mouseover", handleOpen);
          el.addEventListener("mouseout", handleClose);

          // Focus events for accessibility
          el.addEventListener("focus", handleOpen, true);
          el.addEventListener("blur", handleClose, true);
        }
      );
    },
  };

  Drupal.behaviors.toggleMobileMenu = {
    attach: function (context, settings) {
      // Mobile menu activation
      once("mobile-menu-toggle", "#mobile-menu-toggle", context).forEach(
        (el) => {
          const $container = document.querySelector(".header--mobile");
          el.addEventListener("click", (e) => {
            el.classList.toggle("is-open");
            $container.classList.toggle("is-open");
            e.preventDefault();
          });
        }
      );
    },
  };

  Drupal.behaviors.splide = {
    attach: function (context, settings) {
      // Splide
      once("splide", ".splide", context).forEach(() => {
        new Splide(".splide", {
          arrows: true,
          autoplay: true,
          interval: 5000,
          speed: 1000,
          type: "fade",
        }).mount();
      });
    },
  };

  Drupal.behaviors.listFilter = {
    attach: function (context, settings) {
      once(
        "list-filter",
        ".view-designers, .view-firms, .view-clients",
        context
      ).forEach((el) => {
        const $header = el.querySelector(".view-header");
        const $filter = el.querySelector("#edit-title");
        const $results = el.querySelector(".view-content");

        // Prevent the default submit action.
        const $submitButton = el.querySelector(".form-submit");
        $submitButton.addEventListener("click", (e) => {
          e.preventDefault();
        });

        $filter.addEventListener("keyup", () => {
          const selectedValue = $filter.value;
          const $items = $results.querySelectorAll(".views-row");
          let count = 0;

          $items.forEach((item) => {
            if (
              item.textContent
                .toLowerCase()
                .includes(selectedValue.toLowerCase())
            ) {
              item.classList.remove("hidden");
              count++;
            } else {
              item.classList.add("hidden");
            }
          });
          // Set the header text with the results.
          if ($header) {
            $header.textContent = `${count} results`;
          }
        });
      });
    },
  };

  Drupal.behaviors.accordion = {
    attach: function (context, settings) {
      // Mark body as JS-enabled for CSS targeting.
      document.body.classList.add("js-enabled");

      // Initialize accordions.
      once("accordion", ".accordion", context).forEach((accordion) => {
        const firstOpen = accordion.getAttribute("data-first-open") === "true";
        const items = accordion.querySelectorAll(".accordion-item");

        // Open first item if configured.
        if (firstOpen && items.length > 0) {
          const firstItem = items[0];
          firstItem.classList.add("is-open");
          const firstTrigger = firstItem.querySelector(".accordion-item__trigger");
          if (firstTrigger) {
            firstTrigger.setAttribute("aria-expanded", "true");
          }
        }

        // Handle trigger clicks.
        once("accordion-trigger", ".accordion-item__trigger", accordion).forEach(
          (trigger) => {
            trigger.addEventListener("click", (e) => {
              const item = trigger.closest(".accordion-item");
              const isOpen = item.classList.contains("is-open");

              // Close all items in this accordion (single-expand behavior).
              items.forEach((otherItem) => {
                if (otherItem !== item) {
                  otherItem.classList.remove("is-open");
                  const otherTrigger = otherItem.querySelector(
                    ".accordion-item__trigger"
                  );
                  if (otherTrigger) {
                    otherTrigger.setAttribute("aria-expanded", "false");
                  }
                }
              });

              // Toggle current item.
              if (isOpen) {
                item.classList.remove("is-open");
                trigger.setAttribute("aria-expanded", "false");
              } else {
                item.classList.add("is-open");
                trigger.setAttribute("aria-expanded", "true");
              }
            });

            // Keyboard support.
            trigger.addEventListener("keydown", (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                trigger.click();
              }
            });
          }
        );
      });
    },
  };
})(Drupal, drupalSettings);
